import React from 'react'

const Loader = () => {
  return (
    <div className="spinner">
        <img src="/assets/img/logo-left.svg" alt="" loading="eager" className="animate-rotate"/>
    </div>
  )
}

export default Loader